import Measurer from "../Measurer";
import RFAbstract from "./RFAbstract";

export default class RFInterieur extends RFAbstract {

    constructor(interactionHandler) {
        super(interactionHandler);
    }

    getRestraints() {
        let snaps = [];
        const interieur = this.dragObject3d.vsData;
        let draggedKonstruktionsboedenDeltas = this._getDraggedKonstruktionsboedenDeltas();
        const ranges = [];
        APP.arrangement.iterateElements(element => {
            if (interieur.acceptElement(element)) {
                const fits = new Measurer(Measurer.CENTER).getInterieurYFits(interieur, element);
                const box = element.localToSchrankBox(interieur.getElementBox(element));
                if (element.getNumberOfParentElements() > 0 && interieur.element === element) {
                    draggedKonstruktionsboedenDeltas = this._getDraggedKonstruktionsboedenDeltas(element.schrankBox.min.y);
                }
                fits.forEach(fit=>ranges.push({fit, element, box}));
                const snapYsInElement = this._getSnapYsInElement(element, fits, draggedKonstruktionsboedenDeltas);
                snaps = snaps.concat(snapYsInElement);
            }
        });

        const restraints = this._mapFitsToRestraints(ranges, {});

        return this._addRoomAndRemoveRestraints(restraints.concat(snaps));
    }

    _getDraggedKonstruktionsboedenDeltas(yDelta = 0) {
        const deltas = [];
        const interieur = this.dragObject3d.vsData;
        const brett_staerke = APP.settings.getFloat('brett_staerke');
        const height = interieur.getHeight(false, false);
        const y = (height + brett_staerke) / 2;
        if (interieur.needsBoden.bottom) {
            deltas.push(y-yDelta);
        }
        if (interieur.needsBoden.top) {
            deltas.push(-(y+yDelta));
        }
        return deltas;
    }

}
